import React, { createContext, useContext, useMemo } from 'react';
import type { Dispatch } from 'react';
import type { ClinicalAction, ClinicalState } from '../types/clinicalDemo';
import { useDemoStore } from '../utils/demoStorage';
import { clinicalReducer, clinicalStorageKey, createInitialClinicalState } from '../utils/clinicalDemo';
type ClinicalDemoValue = {
  state: ClinicalState;
  dispatch: Dispatch<ClinicalAction>;
  reset: () => void;
  persistenceOk: boolean;
};
const ClinicalDemoContext = createContext<ClinicalDemoValue | null>(null);
export function ClinicalDemoProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const {
    state,
    dispatch,
    reset,
    persistenceOk
  } = useDemoStore(clinicalStorageKey, clinicalReducer, createInitialClinicalState);
  const value = useMemo(() => ({
    state,
    dispatch,
    reset,
    persistenceOk
  }), [state, dispatch, reset, persistenceOk]);
  return <ClinicalDemoContext.Provider value={value} data-id="element-2846" data-mp="39boi6njgeenz">{children}</ClinicalDemoContext.Provider>;
}
export function useClinicalDemo() {
  const value = useContext(ClinicalDemoContext);
  if (!value) throw new Error('useClinicalDemo must be used within ClinicalDemoProvider');
  return value;
}